import type { KyInstance, Options } from "ky";

import { HTTPError, default as kyLib } from "ky";

import { getEnv } from "./solvariEnv.ts";

const csrfSafeMethods = new Set(["GET", "HEAD", "OPTIONS"]);

// Same-origin only: cross-origin → token leak + CORS preflight rejects x-xsrf-token.
function attachXsrfToken(request: Request) {
  if (typeof document === "undefined" || csrfSafeMethods.has(request.method)) {
    return;
  }
  if (new URL(request.url).origin !== document.location.origin) {
    return;
  }
  const token = /(?:^|; )XSRF-TOKEN=([^;]*)/.exec(document.cookie)?.[1];
  if (token) {
    request.headers.set("X-XSRF-TOKEN", decodeURIComponent(token));
  }
}

const ky: KyInstance = kyLib.create({
  credentials: "include",
  headers: { accept: "application/json" },
  hooks: {
    beforeRequest: [attachXsrfToken],
    afterResponse: [
      (_request, _options, response) => {
        if (response.status === 401) {
          const redirectUrl = getEnv().network.auth.baseWithPrefix;

          if (!window.location.href.includes(redirectUrl)) {
            window.location.href = redirectUrl;
          }
        }
      },
    ],
  },
});

const kyNoCredentials: KyInstance = kyLib.create({
  headers: { accept: "application/json" },
});

export { HTTPError, ky, kyNoCredentials, type Options as KyOptions };
